import { ArrowRight, Sparkles } from 'lucide-react';

const AnnouncementBanner = () => {
  return (
    <div className="w-full sm:px-4 lg:px-8">
      <div className="sm:container sm:mx-auto sm:max-w-none lg:max-w-7xl xl:max-w-[1400px] 2xl:max-w-[1600px]">
        <a 
          href="https://joinassembly.com/blog/assembly-joins-quantum-workplace"
          target="_blank"
          rel="noopener noreferrer"
          className="group flex items-center justify-center gap-2 sm:gap-3 px-4 py-2.5 sm:py-2 text-white bg-gradient-to-r from-blue-600 via-indigo-600 to-blue-700 sm:rounded-full hover:shadow-lg hover:shadow-blue-500/25 transition-all duration-200"
        >
          {/* Icon - hidden on very small screens */}
          <div className="hidden sm:flex items-center justify-center w-5 h-5 rounded-full bg-white/20">
            <Sparkles className="w-3 h-3 text-white" />
          </div>
          
          {/* Text content - stacks on mobile, inline on larger screens */}
          <div className="flex flex-col sm:flex-row items-center gap-0.5 sm:gap-1.5 text-center sm:text-left">
            <span className="font-semibold text-xs sm:text-sm">
              Assembly is joining Quantum Workplace
            </span>
            <span className="hidden sm:inline text-white/60">—</span>
            <span className="text-white/90 text-xs sm:text-sm">
              Help employees feel valued with greater insight!
            </span>
          </div>
          
          {/* CTA */}
          <span className="flex items-center gap-1 font-semibold text-xs sm:text-sm whitespace-nowrap ml-1 sm:ml-2 underline underline-offset-2 decoration-white/50 group-hover:decoration-white transition-all">
            Read More
            <ArrowRight className="w-3 h-3 transition-transform duration-300 group-hover:translate-x-0.5" />
          </span>
        </a>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
